import dynamic from "next/dynamic";

import type { Props as HeaderOnelineMenuContainerProps } from "~/components/home/header/home-header-oneline-menu-container";

export const DynamicHomeHeaderOnelineMenuContainer = dynamic<HeaderOnelineMenuContainerProps>(() =>
  import("../header/home-header-oneline-menu-container").then(
    module => module.HomeHeaderOnelineMenuContainer,
  ),
);
